<script setup>
import { Link } from '@inertiajs/vue3';

const props = defineProps({
    label: String,
    active: Boolean,
    href: String,
});
</script>

<template>
    <Link
        v-if="href"
        :href="href"
        class="uppercase"
        :class="{ 'underline decoration-2 underline-offset-4': active }"
    >
        {{ label }}
    </Link>
    <button
        v-else
        class="mb-2 flex items-center gap-3 text-base uppercase"
    >
        <span :class="{ 'underline decoration-2 underline-offset-4': active }">{{ label }}</span>
    </button>
</template>
